import React, { useEffect, useState } from "react";
import "./index.scss";

import { useNavigate } from "react-router-dom";

import ContactService from "../../../services/contact/contact.service";
import OffreDemandeService from "../../../services/offreDemande/offreDemande.service";
import { showErrorToaster } from "../../../components/toaster/error";
import DataTableDisplay from "../../../components/tableMission";

const offreDemandeService = new OffreDemandeService();

function DemandeOffreListe() {
  const [contacts, setContact] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const loadData = async () => {
    setIsLoading(true);

    try {
      const res = await offreDemandeService?.getAllOffreDemande();
      setContact(res?.data);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }

    setIsLoading(false);
  };
  console.log(contacts);
  useEffect(() => {
    loadData();
  }, []);
  const apiUrl = `${process.env.REACT_APP_API_URL}`;
  function getImageURL(candidatureId) {
    return `${apiUrl}demande-pack/${candidatureId}/file`;
  }
  const columnsContacts = [
    {
      name: "Nom et Prénom",
      selector: (row) => (
        <div className="table-text capitalize">
          {row?.fullname != null && row?.fullname}
        </div>
      ),
      hide: "md",
      sortable: true,
    },
    {
      name: "Entreprise",
      selector: (row) => (
        <div className="table-text capitalize">
          {row?.company != null && row?.company}
        </div>
      ),
      hide: "md",
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => (
        <div className="table-text capitalize">
          {row?.email != null && row?.email}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Télephone",
      selector: (row) => (
        <div className="table-text">{row?.phone != null && row?.phone}</div>
      ),
      hide: "md",
      sortable: true,
    },
    {
      name: "Pack type",
      selector: (row) => (
        <div className="table-text">{row?.type != null && row?.type}</div>
      ),
      hide: "md",
      sortable: true,
    },
    {
      name: "Message",
      selector: (row) => (
        <div className="table-text">{row?.message != null && row?.message}</div>
      ),
      hide: "md",
      sortable: true,
    },
    {
      name: "File",
      selector: (row) => (
        <div className="table-text">
          {" "}
          <a href={getImageURL(row?._id)} target="_blank">
            {row?.file != null && row?.file}
          </a>
        </div>
      ),
      sortable: true,
    },
  ];

  return (
    <section className="usersPage">
      <div className="container-fluid">
        <div className="row my-0 my-md-5 align-items-center">
          <div className="col-sm text-center text-sm-start">
            <h3>Demandes des packs liste</h3>
          </div>
        </div>

        {isLoading ? (
          <div className="d-flex my-0 my-md-5  justify-content-center align-items-center"></div>
        ) : (
          <div className="my-5 py-2">
            <DataTableDisplay columns={columnsContacts} data={contacts} />
          </div>
        )}
      </div>
    </section>
  );
}

export default DemandeOffreListe;
